import { FunctionComponent } from "react";
import { LocationFilter } from "@App/Components/Filters";
import { SubmitButton } from "@App/Components/atoms/whitelabel/home/SubmitButton";
import { StepWrapper } from "@App/Components/atoms/whitelabel/home/stepper/StepWrapper";
import { ValidationWrapper } from "@App/Components/atoms/forms/ValidationWrapper";
import { useSelector } from "react-redux";
import type { State } from "@App/state";

type LocationStepProps = {
  submit: () => void;
  button: {
    text: string;
  };
  error?: string | null;
};

export const LocationStep: FunctionComponent<LocationStepProps> = ({
  submit,
  button,
  error,
}: LocationStepProps) => {
  const place = useSelector((state: State) => state.orders.place);

  return (
    <StepWrapper>
      <ValidationWrapper error={error}>
        <LocationFilter />
      </ValidationWrapper>
      <SubmitButton disabled={!place} text={button.text} onClick={submit} />
    </StepWrapper>
  );
};
